import { render } from "./GridFuncxFolha2.vue?vue&type=template&id=0d0cb892"
import script from "./GridFuncxFolha2.vue?vue&type=script&lang=js"
export * from "./GridFuncxFolha2.vue?vue&type=script&lang=js"

import "./GridFuncxFolha2.vue?vue&type=style&index=0&id=0d0cb892&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__